import { ICellRendererParams, IRowNode } from 'ag-grid-community';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  TasksService,
  TaskType,
} from '@compumark/analyst-selection-tool-client';
import { BehaviorSubject, first } from 'rxjs';

@Component({
  selector: 'app-hold-popup',
  standalone: false,
  templateUrl: './hold-popup.component.html',
  styleUrls: ['./hold-popup.component.scss'],
})
export class HoldPopupComponent {
  reason$ = new BehaviorSubject<string>('');
  hold$ = new BehaviorSubject<boolean>(false);
  params: ICellRendererParams;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private taskService: TasksService,
    private dialogRef: MatDialogRef<HoldPopupComponent>,
  ) {
    this.hold = data.hold;
    this.params = data.params;
  }

  get reason(): string {
    return this.reason$.getValue();
  }

  set reason(value: string) {
    this.reason$.next(value);
  }

  get hold(): boolean {
    return this.hold$.getValue();
  }

  set hold(value: boolean) {
    this.hold$.next(value);
  }

  onHold(): void {
    if (this.reason?.trim()) {
      this.updateHoldStatus(this.reason, true);
      this.dialogRef.close();
    }
  }

  onConfirm(): void {
    this.updateHoldStatus(this.reason, false);
    this.dialogRef.close();
  }

  updateHoldStatus(reason: string, isHold: boolean): void {
    this.taskService
      .updateHoldStatus({ reason, hold: isHold }, this.params.data.id)
      .pipe(first())
      .subscribe(() => {
        this.reason = reason;
        this.hold = isHold;
        this.updateRelatedTask();
      });
  }

  updateRelatedTask(): void {
    const rowNodes: IRowNode[] = this.params.api?.getRenderedNodes();
    const updateNode = (node: IRowNode) => {
      node.setDataValue('holdStatus', { hold: this.hold, reason: this.reason });
    };

    const relatedNodes =
      this.params.data.taskType === TaskType.CCLA
        ? rowNodes?.filter((node) => node.data.id === this.params.data.id)
        : rowNodes?.filter(
            (node) =>
              node.data.orderId === this.params.data.orderId &&
              [TaskType.QUALITY, TaskType.SELECTION].includes(
                node.data.taskType,
              ),
          );

    relatedNodes?.forEach(updateNode);

    this.params.api?.refreshCells({
      rowNodes: relatedNodes,
      suppressFlash: true,
    });
  }
}
